import React from "react";
import { SITE_URL } from "@/misc/constants";

export default () => (
  <>
    <h1>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>
    <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
    <p>
      1.1. Настоящее Пользовательское соглашение (далее – Соглашение) относится
      к Сайту Интернет-сервиса «Simpo», расположенному по адресу {SITE_URL}, и
      ко всем соответствующим Сайтам, связанным с Сайтом Интернет-сервиса.
    </p>
    <p>
      1.2. Сайт Интернет-сервиса «Simpo Online» (далее – Сайт) является
      собственностью, включая все программно-технические средства,
      обеспечивающие работу Сайта, права на объекты интеллектуальной
      собственности на программы ЭВМ принадлежат Индивидуальному предпринимателю
      Москалевой Алене Владимировне ИНН 519056342309, ОГРН 317784700351214 (г.
      Санкт-Петербург, ул. Адмирала Черокова, 18)
    </p>
    <p>
      1.3. Настоящее Соглашение регулирует отношения между Администрацией Сайта
      Интернет- сервиса «Simpo» (далее – Администрация Сайта) и Пользователем
      данного Сайта.
    </p>
    <p>
      1.4. Продолжение использования Сайта Пользователем означает принятие
      Соглашения и изменений, внесенных в настоящее Соглашение.
    </p>
    <p>
      1.5. Пользователь несет персональную ответственность за проверку
      настоящего Соглашения на наличие изменений в нем.
    </p>
    <h2>2. ОПРЕДЕЛЕНИЯ ТЕРМИНОВ</h2>
    <p>
      2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения
      следующее значение:
    </p>
    <p>
      <strong>2.1. Администрация Сайта</strong> - представители Сервиса,
      осуществляющие техническую поддержку Сервиса и консультационную поддержку
      Пользователей, действующие от лица и в интересах Организации.
    </p>
    <p>
      <strong>2.2. Клиент</strong> – пользователь Сайта, зарегистрированный на
      Сайте в качестве Покупателя, заключивший с Мастером Соглашение, используя
      Защищенные страницы Сайта. Клиентом может быть полностью дееспособное
      физическое лицо, резидентом или нерезидентом Российской Федерации, а также
      индивидуальный предприниматель, зарегистрированный в соответствии с
      законодательством Российской Федерации или любого иного государства, а
      также юридическое лицо, созданное в соответствии с законодательством
      Российской Федерации или любого иного государства.
    </p>
    <p>
      <strong>2.3. Мастер</strong> — пользователь Сайта, зарегистрированный на
      Сайте в качестве Продавца услуг, заключивший с Клиентом Соглашение.
      Мастером может быть полностью дееспособное физическое лицо, достигшее
      восемнадцатилетнего возраста, резидентом или нерезидентом Российской
      Федерации, а также индивидуальный предприниматель, зарегистрированный в
      соответствии с законодательством Российской Федерации или любого иного
      государства, атакже юридическое лицо, созданное в соответствии с
      законодательством Российской Федерации или любого иного государства.
    </p>
    <p>
      <strong>2.4. Интернет-Сервис</strong> - совокупность программных и
      аппаратных средств для ЭВМ, обеспечивающих публикацию для обозрения
      информации и данных, объединенных общим целевым назначением, посредством
      технических средств, применяемых для связи между ЭВМ в сети Интернет.
      Иными словами под понятием Сервиса понимается Сайт/Приложение в
      информационно-телекоммуникационной сети Интернет, расположенный по адресу{" "}
      {SITE_URL}
    </p>
    <p>
      <strong>2.5. Стороны</strong> – Клиент и Мастер при их совместном
      упоминании, а Сторона – любое из них при упоминании по отдельности.
    </p>
    <p>
      <strong>2.6. «Simpo»</strong> – Интернет-сервис, расположенный на доменном
      имени {SITE_URL}, осуществляющий свою деятельность посредством
      Интернет-ресурса и сопутствующих ему сервисов.
    </p>
    <p>
      <strong>2.7. Партнер</strong> - Пользователь Интернет-сервиса, Клиент или
      Мастер, являющийся участником Партнерской программы, распространяющий
      реферальные ссылки с целью привлечения рефералов.
    </p>
    <p>
      <strong>2.8. Партнерская программа</strong> - формат взаимодействия между
      Интернет-сервисом, Клиентами и Мастерами, в рамках которого Партнер
      распространяет реферальные ссылки, приглашая других Пользователей
      зарегистрироваться в Интернет-сервисе.
    </p>
    <p>
      <strong>
        2.9. Пользователь Сайта Интернет-сервиса (далее - Пользователь)
      </strong>{" "}
      – лицо, имеющее доступ к Сайту посредством сети Интернет и использующее
      Сайт.
    </p>
    <p>
      <strong>2.10. Реферал</strong> - Пользователь, приглашенный в
      Интернет-сервис участником Партнерской программы, зарегистрировавшийся в
      системе и начавший совершать сделки от своего имени в системе.
    </p>
    <p>
      <strong>
        2.11. Содержание Сайта Интернет-сервиса (далее – Содержание)
      </strong>{" "}
      - охраняемые результаты интеллектуальной деятельности, включая тексты
      литературных произведений, их названия, предисловия, аннотации, статьи,
      иллюстрации, обложки, музыкальные произведения с текстом или без текста,
      графические, текстовые, фотографические, производные, составные и иные
      произведения, пользовательские интерфейсы, визуальные интерфейсы, названия
      товарных знаков, логотипы, программы для ЭВМ, базы данных, а также дизайн,
      структура, выбор, координация, внешний вид, общий стиль и расположение
      данного Содержания, входящего в состав Сайта и другие объекты
      интеллектуальной собственности все вместе и/ или по отдельности,
      содержащиеся на Сайте Интернет-сервиса.
    </p>
    <h2>3. ПРЕДМЕТ СОГЛАШЕНИЯ</h2>
    <p>
      3.1. Предметом настоящего Соглашения является предоставление Пользователю
      Интернет-сервиса доступа к информации об оказываемых услугах
      специалистами, анкеты с предложениями которых размещены на Сайте, а также
      к контенту, владельцем которого являются другие Пользователи.
      Интернет-сервис не несёт ответственности за качество оказываемых услуг,
      выполняя лишь информационно-справочную роль во взаимоотношениях Клиента и
      Мастера.
    </p>
    <p>
      3.1.1. Интернет-сервис предоставляет Пользователю следующие виды услуг:
    </p>
    <ul>
      <li>
        доступ к электронному контенту, размещаемому на страницах
        Интернет-сервиса;
      </li>
      <li>доступ к средствам поиска и навигации Интернет-сервиса;</li>
      <li>
        предоставление Пользователю возможности размещения услуг, промо-акций,
        объявлений, сообщений, комментариев, отзывов, выставления оценок
        контенту других Пользователей Интернет-сервиса;
      </li>
      <li>
        доступ к информации об услугах и к информации о приобретении Услуги на
        платной основе;
      </li>
      <li>
        доступ к сервисам управления бизнесом, взаимоотношениям с клиентами,
        информирования и др.;
      </li>
      <li>иные виды услуг, реализуемые на страницах Интернет-сервиса.</li>
    </ul>
    <p>
      3.1.2. Под действие настоящего Соглашения подпадают все существующие
      (реально функционирующие) на данный момент услуги Интернет-сервиса, а
      также любые их последующие модификации и появляющиеся в дальнейшем
      дополнительные услуги.
    </p>
    <p>
      3.2. Доступ к Интернет-сервису предоставляется на бесплатной основе. При
      оплате услуг по схеме "Безопасная сделка" клиент оплачивает только
      стоимость Услуг конкретного Мастера. Мастер оплачивает комиссию
      Интернет-сервиса в фиксированном размере 12% за каждую Сделку по факту
      оплаты клиентом услуги мастера. При запросе возврата денежных средств при
      отказе от покупки, возврат производится исключительно на ту же банковскую
      карту, с которой была произведена оплата.
    </p>
    <p>
      3.3. Настоящее Соглашение является публичной офертой. Получая доступ к
      Сайту Пользователь считается присоединившимся к настоящему Соглашению.
    </p>
    <p>
      3.4. Использование материалов и сервисов Сайта регулируется нормами
      действующего законодательства Российской Федерации.
    </p>
    <h2>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
    <strong>4.1. Администрация Сайта вправе:</strong>
    <p>
      4.1.1. Изменять правила пользования Сайтом, а также изменять содержание
      данного Сайта. Изменения вступают в силу с момента публикации новой
      редакции Соглашения на Сайте.
    </p>
    <p>
      4.1.2. Ограничить доступ к Сайту в случае нарушения Пользователем условий
      настоящего Соглашения.
    </p>
    <p>
      4.1.3. Изменять размер оплаты, взимаемый за предоставление доступа к
      использованию Сайта Интернет-сервиса.
    </p>
    <strong>4.2. Пользователь вправе:</strong>
    <p>
      4.2.1. Получить доступ к использованию Сайта после соблюдения требований о
      регистрации оплате.
    </p>
    <p>4.2.2. Пользоваться всеми имеющимися на Сайте услугами.</p>
    <p>
      4.2.3. Задавать любые вопросы, относящиеся к услугам Интернет-сервиса по
      реквизитам, которые находятся в футере сайта.
    </p>
    <p>
      4.2.4. Пользоваться Сайтом исключительно в целях и порядке,
      предусмотренных Соглашением и не запрещенных законодательством Российской
      Федерации.
    </p>
    <strong>4.3. Пользователь Сайта обязуется:</strong>
    <p>
      4.3.1. Предоставлять по запросу Администрации Сайта дополнительную
      информацию, которая имеет непосредственное отношение к предоставляемым
      услугам данного Сайта.
    </p>
    <p>
      4.3.2. Соблюдать имущественные и неимущественные права авторов и иных
      правообладателей при использовании Сайта.
    </p>
    <p>
      4.3.3. Не предпринимать действий, которые могут рассматриваться как
      нарушающие нормальную работу Сайта.
    </p>
    <p>
      4.3.4. Не распространять с использованием Сайта любую конфиденциальную и
      охраняемую законодательством Российской Федерации информацию о физических
      либо юридических лицах.
    </p>
    <p>
      4.3.5. Избегать любых действий, в результате которых может быть нарушена
      конфиденциальность охраняемой законодательством Российской Федерации
      информации.
    </p>
    <p>
      4.3.6. Не использовать Сайт для распространения информации рекламного
      характера, иначе как с согласия Администрации Сайта.
    </p>
    <p>4.3.7. Не использовать сервисы Сайта Интернет-сервиса с целью:</p>
    <p>
      4.3.7.1. Загрузки контента, который является незаконным, нарушает любые
      права третьих лиц; пропагандирует насилие, жестокость, ненависть и (или)
      дискриминацию по расовому, национальному, половому, религиозному,
      социальному признакам; содержит недостоверные сведения и (или) оскорбления
      в адрес конкретных лиц, организаций, органов власти.
    </p>
    <p>
      4.3.7.2. Побуждения к совершению противоправных действий, а также
      содействия лицам, действия которых направлены на нарушение ограничений и
      запретов, действующих на территории Российской Федерации.
    </p>
    <p>
      4.3.7.3. Нарушения прав несовершеннолетних лиц и (или) причинение им вреда
      в любой форме.
    </p>
    <p>4.3.7.4. Ущемления прав меньшинств.</p>
    <p>
      4.3.7.5. Представления себя за другого человека или представителя
      организации и (или) сообщества без достаточных на то прав, в том числе за
      сотрудников данного Интернет- сервиса.
    </p>
    <p>
      4.3.7.6. Введения в заблуждение относительно свойств и характеристик
      какой-либо Услуги из каталога Интернет-сервиса, размещенного на Сайте.
    </p>
    <p>
      4.3.7.7. Некорректного сравнения Услуги, а также формирования негативного
      отношения к лицам, (не) пользующимся определенными Услугами, или осуждения
      таких лиц.
    </p>
    <p>
      4.3.8. Исполнять свои обязательства, связанные с уплатой налогов и других
      сборов в бюджет Российской Федерации, если такие возникают в процессе
      использования Интернет-сервиса, в т.ч. налог на доходы физических лиц или
      самозанятых, налог на прибыль, взносы на обязательное пенсионное
      страхование и пр.
    </p>
    <strong>4.4. Пользователю запрещается:</strong>
    <p>
      4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и
      методы, автоматические устройства или эквивалентные ручные процессы для
      доступа, приобретения, копирования или отслеживания содержания Сайта
      данного Интернет-сервиса;
    </p>
    <p>4.4.2. Нарушать надлежащее функционирование Сайта;</p>
    <p>
      4.4.3. Любым способом обходить навигационную структуру Сайта для получения
      или попытки получения любой информации, документов или материалов любыми
      средствами, которые специально не представлены сервисами данного Сайта;
    </p>
    <p>
      4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам
      или сетям, относящимся к данному Сайту, а также к любым услугам,
      предлагаемым на Сайте;
    </p>
    <p>
      4.4.5. Нарушать систему безопасности или аутентификации на Сайте или в
      любой сети, относящейся к Сайту.
    </p>
    <p>
      4.4.6. Выполнять обратный поиск, отслеживать или пытаться отслеживать
      любую информацию о любом другом Пользователе Сайта.
    </p>
    <p>
      4.4.7. Использовать Сайт и его Содержание в любых целях, запрещенных
      законодательством Российской Федерации, а также подстрекать к любой
      незаконной деятельности или другой деятельности, нарушающей права
      интернет-сервиса или других лиц.
    </p>
    <h2>5. ИСПОЛЬЗОВАНИЕ САЙТА ИНТЕРНЕТ-СЕРВИСА</h2>
    <p>
      5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется
      Администрацией Сайта.
    </p>
    <p>
      5.2. Содержание Сайта не может быть скопировано, опубликовано,
      воспроизведено, передано или распространено любым способом, а также
      размещено в глобальной сети «Интернет» без предварительного письменного
      согласия Администрации Сайта.
    </p>
    <p>
      5.3. Содержание Сайта защищено авторским правом, законодательством о
      товарных знаках, а также другими правами, связанными с интеллектуальной
      собственностью, и законодательством о недобросовестной конкуренции.
    </p>
    <p>
      5.4. Приобретение Товара, предлагаемого на Сайте, может потребовать
      создания учётной записи Пользователя.
    </p>
    <p>
      5.5. Пользователь несет персональную ответственность за сохранение
      конфиденциальности информации учётной записи, включая пароль, а также за
      всю без исключения деятельность, которая ведётся от имени Пользователя
      учётной записи.
    </p>
    <p>
      5.6. Пользователь должен незамедлительно уведомить Администрацию Сайта о
      несанкционированном использовании его учётной записи или пароля или любом
      другом нарушении системы безопасности.
    </p>
    <p>
      5.7. Администрация Сайта обладает правом в одностороннем порядке
      аннулировать учетную запись Пользователя, если она не использовалась более
      2 календарных месяцев подряд без уведомления Пользователя.
    </p>
    <p>
      5.8. Настоящее Соглашение распространяет свое действия на все
      дополнительные положения и условия о приобретении Услуг, предоставляемых
      на Сайте.
    </p>
    <p>
      5.9. Информация, размещаемая на Сайте не должна истолковываться как
      изменение настоящего Соглашения.
    </p>
    <p>
      5.10. Размещая фотографии, статьи и другой контент на страницах
      Интернет-сервиса и на страницах Личного кабинета, Пользователь
      гарантирует, что является автором контента, и дает право Интернет-сервису
      распоряжаться им по своему усмотрению, публиковать в различных
      интернет-ресурсах, использовать в качестве рекламных материалов на
      условиях неисключительной лицензии. В случае, если Пользователь размещает
      фотографии и контент, авторство на которые ему не принадлежит,
      ответственность за нарушение авторских прав правообладателя несет сам
      Пользователь.
    </p>
    <p>
      5.11. Любой из документов, перечисленных в пункте 5.11. настоящего
      Соглашения, может подлежать обновлению. Изменения вступают в силу с
      момента их опубликования на Сайте.
    </p>
    <h2>6. УЧАСТИЕ В ПАРТНЕРСКОЙ ПРОГРАММЕ</h2>
    <p>
      6.1. Участию в Партнерской программе допускаются любые Пользователи,
      зарегистрировавшиеся в Интернет-сервисе в качестве Клиента или Мастера.
    </p>
    <p>
      6.2. Партнер Интернет-сервиса распространяет реферальные ссылки,
      генерируемые в Личном кабинете, привлекая Рефералов зарегистрироваться в
      Интернет-сервисе любым доступным способом, используя всевозможные каналы
      коммуникации.
    </p>
    <p>
      6.3. Вознаграждение Партнера отображается в Личном кабинете и
      рассчитывается как 5% от подтвержденных трат Клиента и 4% от
      подтвержденного заработка Мастера в Интернет-сервисе.
    </p>
    <p>
      6.4. Платежи Партнерам осуществляются по запросу не чаще 2 раз в месяц по
      достижении минимальной суммы выплат, установленной Интернет-сервисом,
      посредством сервиса Яндекс.Касса.
    </p>
    <p>
      6.5. Интернет-сервис не несет расходов, связанных с привлечением Рефералов
      Партнером.
    </p>
    <p>
      6.6. Интернет-сервис не берет на себя функции налогового агента и
      возлагает ответственность по уплате налоговых, пенсионных и иных взносов,
      предусмотренных законодательством РФ, на Партнера.
    </p>
    <p>
      6.7. Интернет-сервис оставляет за собой право в любой момент изменить
      условия Партнерской программы, в том числе отказаться от ее использования.
    </p>
    <h2>7. ОТВЕТСТВЕННОСТЬ</h2>
    <p>
      7.1. Любые убытки, которые Пользователь может понести в случае умышленного
      или неосторожного нарушения любого положения настоящего Соглашения, а
      также вследствие несанкционированного доступа к коммуникациям другого
      Пользователя, Администрацией Сайта не возмещаются.
    </p>
    <p>7.2. Администрация Сайта не несет ответственности за:</p>
    <p>
      7.2.1. Задержки или сбои в процессе совершения операции, возникшие
      вследствие непреодолимой силы, а также любого случая неполадок в
      телекоммуникационных, компьютерных, электрических и иных смежных системах.
    </p>
    <p>
      7.2.2. Действия систем переводов, банков, платежных систем и за задержки
      связанные с их работой.
    </p>
    <p>
      7.2.3. Надлежащее функционирование Сайта, в случае, если Пользователь не
      имеет необходимых технических средств для его использования, а также не
      несет никаких обязательств по обеспечению пользователей такими средствами.
    </p>
    <h2>8. НАРУШЕНИЕ УСЛОВИЙ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ</h2>
    <p>
      8.1. Администрация Сайта вправе раскрыть любую собранную о Пользователе
      данного Сайта информацию, если раскрытие необходимо в связи с
      расследованием или жалобой в отношении неправомерного использования Сайта
      либо для установления (идентификации) Пользователя, который может нарушать
      или вмешиваться в права Администрации Сайта или в права других
      Пользователей Сайта.
    </p>
    <p>
      8.2. Администрация Сайта имеет право раскрыть любую информацию о
      Пользователе, которую посчитает необходимой для выполнения положений
      действующего законодательства или судебных решений, обеспечения выполнения
      условий настоящего Соглашения, защиты прав или безопасности название
      организации, Пользователей.
    </p>
    <p>
      8.3. Администрация Сайта имеет право раскрыть информацию о Пользователе,
      если действующее законодательство Российской Федерации требует или
      разрешает такое раскрытие.
    </p>
    <p>
      8.4. Администрация Сайта вправе без предварительного уведомления
      Пользователя прекратить и (или) заблокировать доступ к Сайту, если
      Пользователь нарушил настоящее Соглашение или содержащиеся в иных
      документах условия пользования Сайтом, а также в случае прекращения
      действия Сайта либо по причине технической неполадки или проблемы.
    </p>
    <p>
      8.5. Администрация Сайта не несет ответственности перед Пользователем или
      третьими лицами за прекращение доступа к Сайту в случае нарушения
      Пользователем любого положения настоящего Соглашения или иного документа,
      содержащего условия пользования Сайтом.
    </p>
    <h2>9. РАЗРЕШЕНИЕ СПОРОВ</h2>
    <p>
      9.1. В случае возникновения любых разногласий или споров между Сторонами
      настоящего Соглашения обязательным условием до обращения в суд является
      предъявление претензии (письменного предложения о добровольном
      урегулировании спора).
    </p>
    <p>
      9.2. Получатель претензии в течение 30 календарных дней со дня ее
      получения, письменно уведомляет заявителя претензии о результатах
      рассмотрения претензии.
    </p>
    <p>
      9.3. При невозможности разрешить спор в добровольном порядке любая из
      Сторон вправе обратиться в суд за защитой своих прав, которые
      предоставлены им действующим законодательством Российской Федерации.
    </p>
    <p>
      9.4. Любой иск в отношении условий использования Сайта должен быть
      предъявлен в течение 3 (трех) дней после возникновения оснований для иска,
      за исключением защиты авторских прав на охраняемые в соответствии с
      законодательством материалы Сайта. При нарушении условий данного пункта
      любой иск или основания для иска погашаются исковой давностью.
    </p>
    <p>
      9.5. В случае если не удается разрешить возникшие между сторонами споры
      и/или разногласия путем переговоров, то такие споры разрешаются в
      Арбитражном суде г. Санкт-Петербург.
    </p>
    <h2>10. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
    <p>
      10.1. Администрация Сайта не принимает встречные предложения от
      Пользователя относительно изменений настоящего Пользовательского
      соглашения.
    </p>
    <p>
      10.2. Отзывы Пользователя, размещенные на Сайте, не являются
      конфиденциальной информацией и могут быть использованы Администрацией
      Сайта без ограничений.
    </p>
  </>
);
